import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux'
import { ConfigProvider } from 'antd'
import zhCN from 'antd/es/locale/zh_CN';
import moment from 'dayjs';
import 'moment/locale/zh-cn';
moment.locale('en');
import './styles/index.scss';
import App from '../src/routerMap'
import Ecreport from './pages/analyse/yearreport/ecreport'
import "./App.css"
// import "./style.scss"

import configureStore from './store'
const store = configureStore()

import * as serviceWorker from './serviceWorker';
ReactDOM.render(
  <Provider store={store}>
    <ConfigProvider locale={zhCN}>
      <App />
    </ConfigProvider>
  </Provider>,
  document.getElementById('root')
);

if (process.env.NODE_ENV !== 'production' && module.hot) {
  module.hot.accept()
}
// console.log('test---------')





// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
